import { Box } from "@mui/material";
import MapCard from "./MapCard";
import LiveIssueStreamCard from "./LiveIssueStreamCard";
import { usePermissions } from "../../Context/PermissionContext";
import { FEATURE_CODES } from "../../Static/FeatureMapping";

const MapAndIssueStreamSection = ({ globalFilters }) => {
    const { hasPermission, isRbacV2Enabled } = usePermissions();

    // Gate the Live Issue Stream behind BMS_FAULTS_V2. V1 orgs (RBAC v2 off)
    // always see it; V2 orgs need view access to the feature. When hidden,
    // the map stretches to fill the whole row.
    const showIssueStream = !isRbacV2Enabled() || hasPermission(FEATURE_CODES.BMS_FAULTS_V2, 'view');

    return (
        <Box sx={{display: 'flex', gap: showIssueStream ? 2 : 0}}>
            <Box sx={{width: showIssueStream ? '75%' : '100%', display: 'flex'}}>
                <MapCard globalFilters={globalFilters} />
            </Box>
            {showIssueStream && (
                <Box sx={{width: '25%', display: 'flex'}}>
                    <LiveIssueStreamCard globalFilters={globalFilters} />
                </Box>
            )}
        </Box>
    )
}

export default MapAndIssueStreamSection;
